import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

export async function getLocationsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    let url = BACKEND_API_PLACEHOLDER + '/api/lookups/locations/query?'
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  
export async function putLocationsEdit(locationID, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/locations?id=${locationID}`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({requestBody})
  })
      .then(res => res.json()
      .then(data => { return data })
  )
}

export async function postLocationsCreate(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/locations/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getAssetCategoryQuery(query, headers){
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    let url = BACKEND_API_PLACEHOLDER + '/api/lookups/asset_category/query?'
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { 
        if (data.results){
            // standardizing name
            data.results.map(r=>r.name = r.category_name)
        }
        return data })
    )
  }

export async function putAssetCategoryEdit(asset_categoryId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/asset_category?id=${asset_categoryId}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postAssetCategoryCreate(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/asset_category/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getInventoryCategoryQuery(query, headers){
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/lookups/inventory_category/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { 
      if (data.results){
          // standardizing name
          data.results.map(r=>r.name = r.category_name)
      }
      return data })
  )
}

export async function putInventoryCategoryEdit(inventory_categoryId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/inventory_category?id=${inventory_categoryId}`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({requestBody})
  })
      .then(res => res.json()
      .then(data => { return data })
  )
}

export async function postInventoryCategoryCreate(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/inventory_category/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}


export async function getVendorQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/lookups/vendor/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}
  
export async function putVendorEdit(vendorId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/vendor?id=${vendorId}`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({requestBody})
  })
      .then(res => res.json()
      .then(data => { return data })
  )
}

export async function postVendorCreate(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/vendor/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getAssetModelsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/lookups/asset_model/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postAssetModelCreate(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/asset_model/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putAssetModelEdit(modelId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/asset_model?id=${modelId}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getManufacturerQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/lookups/manufacturer/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postManufacturerCreate(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/manufacturer/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putManufacturerEdit(modelId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/manufacturer?id=${modelId}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getUnitOfMeasureQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/lookups/unit_of_measure/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postUnitOfMeasureCreate(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/unit_of_measure/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putUnitOfMeasureEdit(modelId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/lookups/unit_of_measure?id=${modelId}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getChemicalGroupsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/lookups/sensor_group/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
      method: 'GET',
      headers: headers,
  })
  .then(res => res.json()
      .then(data => { return data })
  )
}
